define('modalFooterView',[
  'app',
  'module',
  'marionette',
  'buttonView',
  'underscore',
  'template!modalFooterView'
], function (
  App,
  Module,
  Marionette,
  ButtonView,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'footer-view',

    regions: {
      cancelRegion: '.cancel-region',
      confirmRegion: '.confirm-region'
    },

    onRender: function() {
      this.cancelView = new ButtonView({
        type: 'cancel',
        color: 'grey',
        text: _.i18n('modals.confirmation.cancel'),
        title: _.i18n('modals.confirmation.cancel.title'),
        tabindex: 1
      });
      this.getRegion('cancelRegion').show(this.cancelView);
      this.cancelView.on('click', _.bind(this.onCancel, this));

      //----------------
      var confirmButtonText = _.i18n('modals.confirmation.confirm');
      if(this.options.confirmButtonText)
        confirmButtonText = this.options.confirmButtonText;

      var confirmButtonTitle = _.i18n('modals.confirmation.confirm.title');
      if(this.options.confirmButtonTitle)
        confirmButtonTitle = this.options.confirmButtonTitle;

      this.confirmButtonview = new ButtonView({
        type: 'confirm',
        color: 'orange',
        text: confirmButtonText,
        title: confirmButtonTitle,
        tabindex: 2
      });
      this.confirmRegion.show(this.confirmButtonview);
      this.confirmButtonview.on('click', _.bind(this.onConfirm, this));
    },

    onConfirm: function () {
      this.trigger('confirm');
    },

    onCancel: function () {
      this.trigger('cancel');
    }
  });
});
